import styled from "styled-components";

export const IncDreWrap = styled.div`
  position: relative;
  color: #2f65cb;
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }
  input {
    width: 100%;
    border-radius: 4px;
    border: 1px solid #2f65cb38;
    text-align: center;
    padding: 3px 15px;
    background: #2f65cb0f;
  }

  .beforeIn {
    position: absolute;
    margin: auto;
    left: 0;
    top: 0;
    bottom: 0;
    padding: 0px 10px;
    cursor: pointer;
    font-size: 18px;
    display: flex;
    align-items: center;
  }

  .afterIn {
    position: absolute;
    margin: auto;
    right: 0;
    top: 0;
    bottom: 0;
    padding: 0px 10px;
    cursor: pointer;
    font-size: 18px;
    display: flex;
    align-items: center;
  }

  .indisabled {
    color: #dbd6d6;
  }

  .incdecDisable {
    input,
    .afterIn,
    .beforeIn {
      background: #efefef;
      color: #a6a6a6;
      border: 1px solid #efefef;
      border-radius: 4px;
    }
  }
`;
